export enum InvoiceStatus {
    all = 'all',
    paid = 'paid',
    issued = 'issued'
}
